var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2VbTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4492 12.9555V0.90625H15.1866C16.2719 0.90625 17.1959 1.22183 17.9732 1.86732C18.7506 2.51282 19.1172 3.27307 19.1172 4.16241C19.1172 4.67881 18.9706 5.16652 18.6626 5.62554C18.3546 6.08456 17.9879 6.41448 17.5186 6.58661C18.1492 6.73005 18.6626 7.07432 19.0586 7.60506C19.4546 8.1358 19.6452 8.76695 19.6452 9.48416C19.6452 10.4596 19.2639 11.2916 18.4866 11.9657C17.7092 12.6399 16.7852 12.9698 15.7146 12.9698H10.4492V12.9555ZM13.4412 5.63988H15.0546C15.3626 5.63988 15.6119 5.53947 15.8172 5.35299C16.0226 5.16652 16.1252 4.93701 16.1252 4.65012C16.1252 4.36324 16.0226 4.16241 15.8172 3.97594C15.6119 3.78946 15.3479 3.68905 15.0546 3.68905H13.4412V5.63988ZM13.4412 10.1583H15.4506C15.7879 10.1583 16.0666 10.0436 16.3012 9.82843C16.5359 9.61326 16.6532 9.32638 16.6532 9.0108C16.6532 8.69523 16.5359 8.42268 16.3159 8.19317C16.0959 7.96367 15.8172 7.86325 15.4946 7.86325H13.4559V10.1727L13.4412 10.1583Z",
    fill: "#240b3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390625 0.90625H3.14439L5.99908 8.86977L8.85377 0.90625H11.5643L7.02273 13.0687H4.96101L0.390625 0.90625Z",
    fill: "#240b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2VbTableIcon);
export default __webpack_public_path__ + "static/media/v2-vb-table-icon.477c229baec4d8060501acacaf17fedf.svg";
export { ForwardRef as ReactComponent };